import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
// import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";

import "../private-app/dashboard/dashboard.scss";

// import BuyerService from "../../../services/BuyerService";

interface UserModuleInterface {
  loading?: boolean,
  token?: any,
  error?: any,
  initicialModules: any,
  initicialUser: any,
  name?: string,
};

const UserModule: React.FC<UserModuleInterface> = ({
  loading,
  token,
  error,
  initicialModules,
  initicialUser,
  name,
}) => {
  const [modules, setModules] = useState(initicialModules);
  const [user, setUser] = useState(initicialUser);
  // const [isToggled, setIsToggled] = useState(false);

  // const onToggle = () => setIsToggled(!isToggled);
  // const history = useHistory();

  useEffect(() => {
    setModules(initicialModules);
    // eslint-disable-next-line
  }, [initicialModules]);

  useEffect(() => {
    setUser(initicialUser);
    // eslint-disable-next-line
  }, [initicialUser]);

  return (
    <>
      <div className="user-module-container">
        {name && (
          <div className="user-module-header-container">
            <div className="user-module-header-content">
              <label>Nome:</label>
              <label className="user-module-header-item">{user.name}</label>
            </div>
          </div>
        )}

        <div className="card-container">
          <div className="card">
            <div className="card-header">
              <h1>Módulos disponíveis do usuário</h1>
            </div>
            <div className="card-body">
              <form className="form-container">
                {modules &&
                  modules.length &&
                  modules.map((m: any, index: number) => (
                    <div className="group-input switch-container" key={index}>
                      <label style={{ minWidth: "70%" }}>
                        {m && m.module && m.module.name}
                      </label>
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={true}
                          // onChange={onToggle}
                          disabled
                        />
                        <span className="switch">Ativo</span>
                      </label>
                    </div>
                  ))}

                {/* <button className="global-btn">
                  SALVAR{" "}
                  {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
                </button> */}
              </form>
            </div>
          </div>
        </div>
        {/* <div className="back-container">
          <button
            className="global-btn"
            onClick={() => {
              history.goBack();
            }}
          >
            <FontAwesomeIcon icon={faAngleDoubleLeft} /> VOLTAR{" "}
            {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
          </button>
        </div> */}
      </div>
    </>
  );
}

export default UserModule;